import styled, { keyframes } from "styled-components";
import { Card, Tabs } from "@mui/material";
export const Container = styled.div`
  background: white;
  margin-left: 250px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .hearTrilha {
    display: flex;
    width: 600px;
    height: 168px;
    justify-content: center;
    flex-shrink: 0;
    /* padding: 80px; */

    color: black;
    //font-family: 'Montserrat';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .container {
    display: grid
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-content: center;
    background: none;
  }
  @media (max-width: 700px) {
    gap: 8px;
    margin-left: 0px;

    img {
      align-self: center;
    }

    button {
      width: 100%;
    }
  }
`;
export const ContainerDad = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  overflow: hidden;

  .containerContent {
    @media (max-width: 700px) {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 8px 12px;
  width: 80%;
  margin-left: 260px;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .input {
    flex: 1;
    border: none;
    outline: none;
    padding: 8px;
    font-size: 1em;
    background: transparent;
    color: #333;
  }

  .input::placeholder {
    color: #999;
  }

  button {
    background-color: #2196f3;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-family: "Poppins", sans-serif;
    font-size: 0.95em;
  }

  button:hover {
    background-color: #1976d2;
  }
  @media (max-width: 1700px) {
    width: 80%;
  }
  @media (max-width: 1300px) {
    width: 75%;
  }
  @media (max-width: 700px) {
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
    margin-left: 0;
    img {
      align-self: center;
    }

    button {
      width: 100%;
    }
  }
`;
const scaleIn = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.04);
  }
`;

const scaleOut = keyframes`
  from {
    transform: scale(1.04);
  }
  to {
    transform: scale(1);
  }
`;

export const CardTrilha = styled(Card)`
  width: 370px;
  height: auto;
  border-radius: 5px;
  background: #fff;
  margin: 10px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    animation: ${scaleIn} 0.3s ease-in-out;
    transform: scale(1.04);
  }

  &:not(:hover) {
    animation: ${scaleOut} 0.3s ease-in-out;
  }
`;

export const TabsTrilhas = styled(Tabs)`
  .ant-tabs-tab-btn {
    color: rgba(0, 0, 0, 0.77);
    font-family: "Karla", sans-serif;
    font-weight: 700;
    font-size: 1.1em;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: rgba(212, 109, 13, 1) !important;
    font-weight: 700;
  }
  .ant-tabs-ink-bar {
    position: absolute;
    background: rgba(212, 109, 13, 1);
    pointer-events: none;
  }
  .ant-tabs-nav-wrap {
    border: 1px solid white !important;
  }
`;
